import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { map } from 'rxjs/operators';
import { IDtoCustomer } from 'app/shared/models/customer/dto-customer.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoProject } from 'app/shared/models/customer/dto-project.model';
import { IDtoPlan } from 'app/shared/models/customer/dto-plan.model';
import { IDtoProduct } from 'app/shared/models/position/dto-product.model';

@Injectable()
export class CustomerService {
    private quoteUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
            });
        }
    }
    public getCustomers(): Observable<IResult> {
        const url = `${this.quoteUrl}api/Customers/getCustomers`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateCustomer(dto: IDtoCustomer): Observable<IResult> {
        const url = `${this.quoteUrl}api/Customers/updateCustomer`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addCustomer(dto: IDtoCustomer): Observable<IResult> {
        const url =`${this.quoteUrl}api/Customers/addCustomer`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getProyectsByCustomer(customerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/ProjectCustomers/getProyectsByCustomer?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogCustomers(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Customers/getCatalogCustomers`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogCustomersWithCodeNomPayCompany(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Customers/getCatalogCustomersWithCodeNomPayCompany`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogCustomersByExecutive(userId: string): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Customers/getCatalogCustomersByExecutive?userId=${userId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCustomerById(customerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Customers/getCustomerById?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateProject(dto: IDtoProject): Observable<IResult> {
        const url = `${this.quoteUrl}api/ProjectCustomers/updateProject`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addProject(dto: IDtoProject): Observable<IResult> {
        const url =`${this.quoteUrl}api/ProjectCustomers/addProject`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogCategories(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Categories/getCatalogCategories`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updatePlan(dto: IDtoPlan): Observable<IResult> {
        const url = `${this.quoteUrl}api/PlanTrademarks/updatePlan`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addPlan(dto: IDtoPlan): Observable<IResult> {
        const url =`${this.quoteUrl}api/PlanTrademarks/addPlan`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogAccountExecutives(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/AccountExecutives/getCatalogAccountExecutives`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogApprovers(customerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Approvers/getCatalogApprovers?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCustomerByApproverUserId(userId: string): Observable<IResult> {
        const url = `${this.quoteUrl}api/Customers/getCustomerByApproverUserId?userId=${userId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogApproversByProjectCustomer(projectCustomerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Approvers/getCatalogApproversByProjectCustomer?projectCustomerId=${projectCustomerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogProjectsByCustomerId(customerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/ProjectCustomers/getCatalogProjectsByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPayrollApprovers(projectCustomerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/PayrollApprovers/getCatalogPayrollApprovers?projectCustomerId=${projectCustomerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
}